import { Col, Row, Typography } from 'antd';
import React, { useState } from 'react';
import './BloodChemistryExtractor.less';
import FileUploader from './FileUploader';

const { Title, Paragraph } = Typography;

const BloodChemistryExtractor = ({ 
  selectedFiles, 
  onFilesSelected, 
  onClearFiles, 
  onProcessFiles,
  isProcessing,
  disabled
}) => {
  // 管理OCR状态
  const [isOcrReady, setIsOcrReady] = useState(false);
  
  const handleOcrStatusChange = (ocrReady) => {
    setIsOcrReady(ocrReady);
  };

  return (
    <div className="blood-chemistry-extractor">
      
      {/* 文件上传器 */}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div className="blood-chemistry-extractor-content">
            <FileUploader
              selectedFiles={selectedFiles}
              onFilesSelected={onFilesSelected}
              onClearFiles={onClearFiles}
              onProcessFiles={onProcessFiles}
              isProcessing={isProcessing}
              disabled={disabled}
              pageType="blood-chemistry"
              onOcrStatusChange={handleOcrStatusChange}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BloodChemistryExtractor; 